import React from 'react';
import PropTypes from 'prop-types';
import {injectIntl} from "react-intl";
import DateUtil from "../../../services/DateUtil";

class DateFormat extends React.Component {

  render() {
    const {date, layout} = this.props;

    if (!date){
      return null;
    }

    const formatted = DateUtil.formatDate(date, layout);

    return <span className={this.props.className}>{formatted}</span>;
  }
}

export default injectIntl(DateFormat);

Date.propTypes ={
  date: PropTypes.string
};




// WEBPACK FOOTER //
// ./src/components/common/format/DateFormat.js